(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[741],{

/***/ 1759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createElement = exports.appendNodeAsync = void 0;

var _utils = __webpack_require__(6336);

var resetLoadHandlers = function resetLoadHandlers(node, onload, onerror) {
  return function () {
    node.onload = onload;
    node.onerror = onerror;
  };
};

var appendNodeAsync = function appendNodeAsync(target, node, resolveCallback) {
  return new Promise(function (resolve, reject) {
    var resetHandlers = resetLoadHandlers(node, node.onload, node.onerror);
    node.onload = (0, _utils.handleWith)(resetHandlers, node.onload, function () {
      return resolve(typeof resolveCallback === 'function' ? resolveCallback() : undefined);
    });
    node.onerror = (0, _utils.handleWith)(resetHandlers, node.onerror, target.removeChild.bind(target, node), function () {
      return reject(new Error("Couldn't load ".concat(node.rel || node.tagName, " by url: ").concat(node.href || node.src)));
    });
    target.appendChild(node);
  });
};

exports.appendNodeAsync = appendNodeAsync;

var createElement = function createElement(tagName, nodeProps) {
  return Object.assign(__webpack_require__.g.document.createElement(tagName), nodeProps);
};

exports.createElement = createElement;

/***/ }),

/***/ 13750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _domOps.appendNodeAsync;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _domOps.createElement;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _utils.cacheAll;
  }
});
exports.zf = exports.c7 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38416));

var _domOps = __webpack_require__(1759);

var _utils = __webpack_require__(6336);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var appendStyle = function appendStyle(href, nodeProps) {
  var resolveCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _utils.onlyIfFn)(nodeProps);
  return (0, _domOps.appendNodeAsync)(__webpack_require__.g.document.head, (0, _domOps.createElement)('link', _objectSpread({
    rel: 'stylesheet',
    href: href
  }, (0, _utils.onlyIfNotFn)(nodeProps))), resolveCallback);
};

__webpack_unused_export__ = appendStyle;

var appendScript = function appendScript(src, nodeProps) {
  var resolveCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _utils.onlyIfFn)(nodeProps);
  return (0, _domOps.appendNodeAsync)(__webpack_require__.g.document.body, (0, _domOps.createElement)('script', _objectSpread({
    type: 'text/javascript',
    async: true,
    src: src
  }, (0, _utils.onlyIfNotFn)(nodeProps))), resolveCallback);
};

__webpack_unused_export__ = appendScript;
var importScript = (0, _utils.cacheAll)(appendScript);
exports.c7 = importScript;
var importStyle = (0, _utils.cacheAll)(appendStyle);
exports.zf = importStyle;

/***/ }),

/***/ 6336:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleWith = exports.onlyIfNotFn = exports.onlyIfFn = exports.cacheAll = void 0;

var identity = function identity(x) {
  return x;
};

var withCache = function withCache(cache, fn, getKey, checkCache) {
  return function () {
    var key = getKey.apply(void 0, arguments);
    if (checkCache && cache.has(key)) return cache.get(key);
    var result = fn.apply(void 0, arguments);
    cache.set(key, result);
    return result;
  };
};

var cacheAll = function cacheAll(fn) {
  var getKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var cache = new Map();
  var cached = withCache(cache, fn, getKey, true);
  cached.force = withCache(cache, fn, getKey, false);
  return cached;
};

exports.cacheAll = cacheAll;

var onlyIfFn = function onlyIfFn(value, def) {
  return typeof value === 'function' ? value : def;
};

exports.onlyIfFn = onlyIfFn;

var onlyIfNotFn = function onlyIfNotFn(value, def) {
  return typeof value !== 'function' ? value : def;
};

exports.onlyIfNotFn = onlyIfNotFn;

var handleWith = function handleWith() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  var fnHandlers = handlers.filter(function (handler) {
    return typeof handler === 'function';
  });
  return function polyHandler() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    fnHandlers.forEach(function (handler) {
      return handler.apply(_this, args);
    });
  };
};

exports.handleWith = handleWith;

/***/ }),

/***/ 39116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/Spinner.js




const Spinner = (param)=>{
    let { text ="Working ..."  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: "spinner-overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
            spacing: {
                p: 3
            },
            sx: {
                textAlign: "center"
            },
            className: "spinner-wrapper",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                    role: "status",
                    className: "spinner-border",
                    children: text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "sr-only",
                        children: [
                            text,
                            "."
                        ]
                    })
                }),
                text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                    spacing: {
                        mt: 2
                    },
                    sx: {
                        fontWeight: "medium"
                    },
                    children: text
                })
            ]
        })
    });
};
Spinner.propTypes = {
    text: prop_types.string
};
/* harmony default export */ var Spinner_Spinner = (Spinner);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 12031:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = (String.raw);


/***/ }),

/***/ 66651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

class ApplicationError extends Error {
    toSerializable() {
        const { name , message , code , stack , originalError , tags  } = this;
        return {
            name,
            message,
            code,
            stack: typeof stack === "string" ? stack.split("\n") : stack,
            originalError: originalError ? {
                name: originalError.name,
                code: originalError.code,
                message: originalError.message
            } : null,
            tags
        };
    }
    toJSON() {
        return this.toSerializable();
    }
    constructor(originalError, code = 500, message = ApplicationError.defaultMessage[code], tags = null){
        super(message);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "ApplicationError");
        this.code = code;
        this.originalError = originalError;
        this.stack = (originalError === null || originalError === void 0 ? void 0 : originalError.stack) || new Error().stack;
        this.tags = tags;
    }
}
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "defaultMessage", {
    400: "Bad Request",
    401: "Not Authorized",
    403: "Not Permitted",
    404: "Not Found",
    500: "Internal Error",
    503: "Service Unavailable"
});
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "of", (error)=>error instanceof ApplicationError ? error : new ApplicationError(error, error.code || 500, error.message));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "BadRequest", ()=>new ApplicationError(null, 400));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotAuthorized", ()=>new ApplicationError(null, 401));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "NotFound", ()=>new ApplicationError(null, 404));
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(ApplicationError, "ServiceUnavailable", ()=>new ApplicationError(null, 503));
/* harmony default export */ __webpack_exports__["Z"] = (ApplicationError);


/***/ }),

/***/ 58135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FW": function() { return /* reexport */ anyCaptcha_CastleNotice; },
  "Wl": function() { return /* reexport */ anyCaptcha_GoogleRecaptchaNotice; },
  "Xr": function() { return /* reexport */ useFormActionWithAnyCaptcha; }
});

// UNUSED EXPORTS: AnyCaptchaWrapper

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/assets-dynamic-import/lib/index.js
var lib = __webpack_require__(13750);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/settings.js
const DEFAULT_GOOGLE_RECAPTCHA_GLOBAL_NAME = "grecaptcha";
const DEFAULT_CASTLE_GLOBAL_NAME = "Castle";
const CASTLE_URL = "https://unpkg.com/@castleio/castle-js@latest/dist/castle.browser.js";
const getGoogleRecaptchaUrl = (siteKey)=>"https://www.google.com/recaptcha/api.js?render=".concat(siteKey);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/utils.js
const addStyle = (css)=>{
    __webpack_require__.g.document.head.appendChild(Object.assign(__webpack_require__.g.document.createElement("style"), {
        innerText: css
    }));
};
const prepareGoogleRecaptcha = (googleRecaptcha)=>new Promise((resolve)=>googleRecaptcha.ready(()=>resolve(googleRecaptcha)));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/useAnyCaptcha.js




function useAnyCaptcha(cb, param) {
    let { googleRecaptchaSiteKey , castlePublicKey , action  } = param;
    if (!googleRecaptchaSiteKey || !castlePublicKey) {
        return {
            action: cb,
            type: null
        };
    }
    const [type, setType] = (0,react.useState)("");
    const typeRef = (0,react.useRef)(null);
    const googleRecaptchaRef = (0,react.useRef)(null);
    const castleRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        (0,lib/* importScript */.c7)(getGoogleRecaptchaUrl(googleRecaptchaSiteKey), ()=>__webpack_require__.g[DEFAULT_GOOGLE_RECAPTCHA_GLOBAL_NAME]).then(prepareGoogleRecaptcha).then((googleRecaptcha)=>{
            setType("google-recaptcha");
            typeRef.current = "google-recaptcha";
            googleRecaptchaRef.current = googleRecaptcha;
            addStyle(".grecaptcha-badge { visibility: hidden; }");
        }).catch(()=>{
            (0,lib/* importScript */.c7)(CASTLE_URL, ()=>__webpack_require__.g[DEFAULT_CASTLE_GLOBAL_NAME]).then((castle)=>{
                setType("castle");
                typeRef.current = "castle";
                castleRef.current = castle;
                castle.configure({
                    pk: castlePublicKey
                });
            });
        });
    }, [
        googleRecaptchaSiteKey,
        castlePublicKey
    ]);
    const wrappedCb = (0,react.useCallback)(async function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (typeRef.current === "castle") {
            const castle = castleRef.current;
            if (castle == null) throw new TypeError("Castle is not initialized correctly");
            const token = await castle.createRequestToken();
            return cb(...args, token, "castle");
        }
        if (typeRef.current === "google-recaptcha") {
            const grecaptcha = googleRecaptchaRef.current;
            if (grecaptcha == null) throw new TypeError("Google Recaptcha is not initialized correctly");
            return grecaptcha.execute(googleRecaptchaSiteKey, {
                action
            }).then((token)=>cb(...args, token, "google-recaptcha"));
        }
        return cb(...args);
    }, [
        googleRecaptchaSiteKey,
        castlePublicKey,
        cb,
        type
    ]);
    return {
        type,
        action: wrappedCb
    };
}

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js + 1 modules
var DiPageHoC = __webpack_require__(44611);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useActionResult.js
var useActionResult = __webpack_require__(99112);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useActionError.js + 1 modules
var useActionError = __webpack_require__(41194);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/useFormActionWithAnyCaptcha.js





function useFormActionWithAnyCaptcha(formAction, param) {
    let { endOn , ...captchaConfig } = param;
    const actionWithDi = (0,DiPageHoC/* useRun */.Sr)(formAction);
    const { action: actionWithCaptcha , type  } = useAnyCaptcha(actionWithDi, captchaConfig);
    const [actionWithResult, { error , result , reset  }] = (0,useActionResult/* default */.Z)(actionWithCaptcha);
    const [trackableAction, isLoading] = (0,useTracking/* default */.ZP)(actionWithResult, endOn);
    return [
        (0,useActionError/* default */.Z)(trackableAction),
        {
            error,
            result,
            isLoading,
            reset,
            type
        }
    ];
}

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/GoogleRecaptchaNotice.js



const GoogleRecaptchaNotice = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
        sx: {
            fontSize: "xs",
            fontColor: "black--40"
        },
        ...props,
        children: [
            "Protected by reCAPTCHA (Google ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://policies.google.com/privacy",
                children: "Privacy Policy"
            }),
            " ",
            "and ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://policies.google.com/terms",
                children: "Terms of Service"
            }),
            " apply)."
        ]
    });
/* harmony default export */ var anyCaptcha_GoogleRecaptchaNotice = (GoogleRecaptchaNotice);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/CastleNotice.js



const CastleNotice = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
        sx: {
            fontSize: "xs",
            fontColor: "black--40"
        },
        ...props,
        children: [
            "Protected by Castle (Castle ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://castle.io/privacy/",
                children: "Privacy Policy"
            }),
            " and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://castle.io/terms/",
                children: "Terms and Conditions"
            }),
            " apply)."
        ]
    });
/* harmony default export */ var anyCaptcha_CastleNotice = (CastleNotice);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/AnyCaptchaWrapper.js






const AnyCaptchaWrapper = (param)=>/*#__PURE__*/ {
    let { type , children  } = param;
    return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            !!type && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block/* default */.Z, {
                spacing: {
                    mt: 10
                },
                children: [
                    type === "google-recaptcha" && /*#__PURE__*/ (0,jsx_runtime.jsx)(anyCaptcha_GoogleRecaptchaNotice, {}),
                    type === "castle" && /*#__PURE__*/ (0,jsx_runtime.jsx)(anyCaptcha_CastleNotice, {})
                ]
            })
        ]
    });
};
AnyCaptchaWrapper.propTypes = {
    children: prop_types.node.isRequired,
    type: prop_types.string
};
/* harmony default export */ var anyCaptcha_AnyCaptchaWrapper = ((/* unused pure expression or super */ null && (AnyCaptchaWrapper)));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/anyCaptcha/index.js






/***/ }),

/***/ 77358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hocs_WithMaintenance; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/true-di/esm/index.js + 3 modules
var esm = __webpack_require__(97357);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/gql.js
var gql = __webpack_require__(12031);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithMaintenance/provider.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query maintenanceInfo {\n		getServerInfo {\n			brandMaintenance\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

let cache = null;
let lastUpdate = new Date().getTime();
const cacheTime = 60000; // 60s
const MAINTENANCE_INFO = (0,gql/* default */.Z)(_templateObject());
const maintenanceProvider = (gqlClient)=>{
    if (cache !== null && new Date().getTime() < lastUpdate + cacheTime) {
        return Promise.resolve(cache);
    }
    return gqlClient(MAINTENANCE_INFO).then((param)=>{
        let { getServerInfo: { brandMaintenance  }  } = param;
        return brandMaintenance;
    }).then((v)=>{
        cache = v;
        lastUpdate = new Date().getTime();
        return v;
    });
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithMaintenance/index.js





const L_OFF = "OFF"; // maintenance mode is off
const L_NEW_ECOMM = "NEW_ECOMM"; // stop new ecommerce activity only
const L_NEW_ECOMM_AND_SIGNUPS = "NEW_ECOMM_AND_SIGNUPS"; // stop new ecommerce activity and new signups (including trials)
const L_CUD = "CUD"; // stop all activity modifying anything in the database (create, update, delete)
const LevelValue = {
    [L_OFF]: 0,
    [L_NEW_ECOMM]: 1,
    [L_NEW_ECOMM_AND_SIGNUPS]: 2,
    [L_CUD]: 3
};
const WithMaintenance = (param)=>{
    let { serviceCore , MaintenanceComp  } = param;
    return (param)=>{
        let { level: pageLevel  } = param;
        return (Page)=>{
            const PageWithMaintenance = (param)=>{
                let { maintenance , ...pageProps } = param;
                return maintenance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaintenanceComp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    ...pageProps
                });
            };
            PageWithMaintenance.propTypes = {
                maintenance: prop_types.bool
            };
            Object.assign(PageWithMaintenance, Page); // copying all static props
            PageWithMaintenance.getInitialProps = async function(ctx) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                const { gqlClient  } = (0,esm["default"])({
                    ...serviceCore,
                    globalContext: ()=>ctx
                });
                const envLevel = await maintenanceProvider(gqlClient);
                // No need to run Page getInitialProps if maintance mode is on
                if (LevelValue[envLevel] >= LevelValue[pageLevel]) {
                    return {
                        maintenance: true
                    };
                }
                let pageProps = {};
                if (Page.getInitialProps) {
                    pageProps = await Page.getInitialProps(ctx, ...args);
                }
                return {
                    maintenance: false,
                    ...pageProps
                };
            };
            return PageWithMaintenance;
        };
    };
};
/* harmony default export */ var hocs_WithMaintenance = (WithMaintenance);


/***/ }),

/***/ 38416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(64062);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
var toPrimitive = __webpack_require__(95036);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);